/**
 * @generated SignedSource<<08f409ed0b9c0b56a6cf708c43738be4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetIssueOverviewList_issue$data = ReadonlyArray<{
  readonly createdAt: string;
  readonly id: string;
  readonly task: {
    readonly id: string;
    readonly routine: {
      readonly id: string;
      readonly ownerTeam: {
        readonly name: string;
      } | null;
      readonly title: string;
    };
    readonly title: string;
  };
  readonly taskExecution: {
    readonly id: string;
    readonly sectionVersion: {
      readonly id: string;
      readonly ordinal: number;
      readonly section: {
        readonly assignedTeam: {
          readonly id: string;
          readonly name: string;
        } | null;
        readonly id: string;
      };
      readonly title: string | null;
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIssueOverviewIssueItem_issue">;
  readonly " $fragmentType": "WidgetIssueOverviewList_issue";
}>;
export type WidgetIssueOverviewList_issue$key = ReadonlyArray<{
  readonly " $data"?: WidgetIssueOverviewList_issue$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIssueOverviewList_issue">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "WidgetIssueOverviewList_issue",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "task",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Routine",
          "kind": "LinkedField",
          "name": "routine",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Team",
              "kind": "LinkedField",
              "name": "ownerTeam",
              "plural": false,
              "selections": [
                (v2/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "taskExecution",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "RoutineSectionVersion",
          "kind": "LinkedField",
          "name": "sectionVersion",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ordinal",
              "storageKey": null
            },
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "RoutineSection",
              "kind": "LinkedField",
              "name": "section",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Team",
                  "kind": "LinkedField",
                  "name": "assignedTeam",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v2/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetIssueOverviewIssueItem_issue"
    }
  ],
  "type": "Issue",
  "abstractKey": null
};
})();

(node as any).hash = "e383930293aa170d49530794448324b0";

export default node;
